import {useState, useEffect} from 'react'
import { Filter as LucideFilter, ChevronRight } from 'lucide-react'

export const FilterHomeNew = ({catalogos, setFiltroCadena, id}) => {

	const [Head, setHead] = useState('Filtrar Catálogos')
	const [total, setTotal] = useState(null)
	const [Length, setLength] = useState(false)
	const [active, setActive] = useState(false)
	const cantidadPorNombreCadena = {};

	if(catalogos){


		catalogos.forEach((element) => {
			const nombreCadena = element.nombre_cadena;

			if (cantidadPorNombreCadena[nombreCadena]) {
				cantidadPorNombreCadena[nombreCadena]++;
			} else {
				cantidadPorNombreCadena[nombreCadena] = 1;
			}
		});

		// Mostrar la cantidad por nombre_cadena
		for (const nombreCadena in cantidadPorNombreCadena) {
			console.log(`Nombre Cadena: ${nombreCadena}, Cantidad: ${cantidadPorNombreCadena[nombreCadena]}`);
		}
	}

	const handleDocumentClick = (event) => {
		const targetClass = event.target.classList;
		const targetId = event.target.id;

		if (
		  !targetClass.contains(id) &&
		  targetId !== id &&
		  !event.target.closest(`.${id}`)
		) {
		  setActive(false);
		}
	  };

	  useEffect(() => {
		document.addEventListener('mousedown', handleDocumentClick);
		return () => {
		  document.removeEventListener('mousedown', handleDocumentClick);
		};
	  }, []);

	return (
		<div className={'FilterHomeNew '+id} >
			<div
				className={id+` head ${active && 'head_active'}`}
				onClick={(e) => {
					setActive(!active)
				}}
				id={id}
			>
				<LucideFilter size={16} color={'#3676F5'} strokeWidth={2} className='filter_icon' />

				<p style={Length ? {fontWeight: 600} : {}}>{Head}</p>


				<span>{total !== null ? total : catalogos && catalogos.length}</span>

				<ChevronRight size={12} color={active ? '#fff' : '#3676F5'} strokeWidth={2} className={`filter_chev ${active ? 'active' : ''}`} />
			</div>
			<ul style={{backgroundColor: "#fff",
				maxHeight: active ? '450px' : '0px',
				overflowX: 'hidden',
				overflowY: active ? 'auto' : 'hidden'}} className={`${id}${active ? ' ul_active' : ''}`}>
					<li>Cadena</li>

					{catalogos && <li
					key={"todos_"+catalogos.length}
					onClick={(e) => {
						setHead('Filtrar Catálogos')
						setActive(false)
						setLength(true)
						setFiltroCadena(null)
						setTotal(null)
					}}
					className={id}
					><a href='#'>Todos <span>{catalogos.length}</span></a></li>}
					{catalogos && Object.keys(cantidadPorNombreCadena)
						.sort((a, b) => a.localeCompare(b))
						.map((nombreCadena) => (
						<li
							key={nombreCadena}
							onClick={(e) => {
								setHead(nombreCadena)
								setActive(false)
								setLength(true)
								setFiltroCadena(nombreCadena.toLocaleUpperCase())
								setTotal(cantidadPorNombreCadena[nombreCadena])
							}}
						>
							<a href='#'>
								{nombreCadena}
								<span>{cantidadPorNombreCadena[nombreCadena]}</span>
							</a>
						</li>
					))}
				</ul>
		</div>
	)
}
